import * as React from 'react';

import { Box, Typography, Stack, useTheme } from '@mui/material';
import { useAuth } from '@dwelvio/auth-react';

import { useNavigate, useSearchParams } from 'react-router';
import { PasswordResetForm } from './components/password-reset-form';

import { IUserData } from '../../types';
import { LogoWithText } from '../../components/logo-with-text';
import { useAlert } from '@dwelvio/react-alert';

export function PasswordResetPage() {
  const { error, resetPassword } = useAuth<IUserData>();
  const navigate = useNavigate();
  const { show } = useAlert();
  const theme = useTheme();
  const [params, setParams] = useSearchParams();

  const token = params.get('token') ?? 'undefined';
  const success = params.get('success');
  const result = params.get('result');
  const username = params.get('username');

  return (
    <Box
      maxWidth="400px"
      minWidth="300px"
      sx={{ mx: 'auto', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}
    >
      <Box
        component="header"
        sx={{ mx: 'auto', py: 3, display: 'flex', alignItems: 'center', justifyContent: 'center' }}
      >
        <LogoWithText color={theme.palette.primary.main} textColor={theme.palette.secondary.dark} height={50} />
      </Box>
      <Box component="main" sx={{ mx: 'auto', py: 3, px: 2 }}>
        <Stack gap={4} sx={{ mb: 2 }}>
          <Typography variant="h4">Obnovenie hesla</Typography>
        </Stack>
        <Stack gap={1} sx={{ mt: 2 }}>
          {!success && (
            <PasswordResetForm
              username={username}
              onSubmit={async (username: string, password: string) => {
                const result = await resetPassword({ username, password, token });
                if (result === 'success') {
                  setParams((prev) => {
                    const newParams = new URLSearchParams(prev);
                    newParams.set('success', '1');
                    newParams.delete('result');
                    newParams.delete('token');
                    return newParams;
                  });
                } else {
                  setParams((prev) => {
                    const newParams = new URLSearchParams(prev);
                    newParams.set('success', '0');
                    newParams.set('result', result);
                    newParams.delete('token');
                    return newParams;
                  });
                }
              }}
            />
          )}
          {success === '1' && (
            <>
              <Typography variant="body1">Vaše heslo bolo úspešne obnovené. Môžete sa prihlásiť.</Typography>
              <Typography variant="body2">
                <a href="/signin">Prihlásiť sa</a>
              </Typography>
            </>
          )}
          {success === '0' && (
            <>
              <Typography variant="body1">Obnovenie hesla sa nepodarilo. Skúste to prosím znova.</Typography>
              {result && (
                <Typography variant="body2" color="error">
                  Chyba: {result}
                </Typography>
              )}
            </>
          )}
        </Stack>
      </Box>
      <Box component="footer" sx={{ py: 3 }}>
        <Typography variant="body2" textAlign="center">
          © dwelvio.com {new Date().getFullYear()}
        </Typography>
      </Box>
    </Box>
  );
}
